import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const MandatoryLabel = styled.span`
  font-style: italic;
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  margin-left: ${(props) => props.theme.spacing()}px;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
`;
